import * as React from 'react';
import styled from 'styled-components';

import { CarouselContext } from './CarouselContext';

export const StyledSlide = styled.li`
  align-items: stretch;
  display: flex;
  max-width: 100%;

  [data-mode='fade'] & {
    transition: opacity 300ms linear;
  }

  [data-mode='fade'] &[data-selected='false'] {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }
`;

export default function CarouselSlide({ children }) {
  const { state, turn } = React.useContext(CarouselContext);
  const ref = React.useRef(null);
  const index = ref.current ? state.slides?.indexOf(ref.current) : -1;
  const isSelected = index > -1 && state.current === index;

  const handleClick = () => {
    if (state.options.clickToSlide) {
      turn(index);
    }
  };

  return (
    <StyledSlide ref={ref} data-selected={isSelected} onClick={handleClick}>
      {children}
    </StyledSlide>
  );
}
